import en from '@vueform/vueform/locales/en'
import tailwind from '@vueform/vueform/dist/tailwind'
import { defineConfig } from '@vueform/vueform'
import builder from '@vueform/builder/plugin'

export default defineConfig({
  theme: tailwind,
  locales: { en },
  locale: 'en',
  showRequired: ['label'],
  apiKey: 'os3y-r2o6-5sgo-gvqw-ithu',
  plugins: [
    builder,
  ],
})